import { useEffect, useState } from 'react';
import { useAuthenticationContext } from 'nekst-api';
import { useLocation } from 'react-router-dom';

export function useSegmentAnalytics() {

  const authenticationContext = useAuthenticationContext();

  const [analyticsReady, setAnalyticsReady] = useState(false);

  const [identified, setIdentified] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
          !function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="03LoVR3guHskdtUx4jkHEBw3AoGGUOAs";;analytics.SNIPPET_VERSION="5.2.0";
          analytics.load("03LoVR3guHskdtUx4jkHEBw3AoGGUOAs");
          }}();
        `;
    document.head.appendChild(script);

    // Poll to check if window.analytics is ready
    const checkAnalytics = setInterval(() => {
      // @ts-ignore
      if (window.analytics) {
        setAnalyticsReady(true);
        clearInterval(checkAnalytics);
      }
    }, 1000); // Check every 100ms

    return () => clearInterval(checkAnalytics);
  }, []);

  // @ts-ignore
  const analyticsApi = window.analytics;

  useEffect(() => {
    if (!analyticsReady) return;

    const user = authenticationContext?.user;

    if (analyticsApi) {
      if (user) {
        analyticsApi.identify(`${user._crispTokenId}`, {
          'email': user.profile.primaryEmail,
          'name': user.profile.name.fullName,
          'hubspotContactId': authenticationContext?.user._hubspotContactId
        })

        setIdentified(true);
      } else {
        analyticsApi.reset();
        setIdentified(false);
      }
    }
  }, [authenticationContext?.user?.id, analyticsReady]);


  const location = useLocation();

  useEffect(() => {
    if (!analyticsReady) return;

    const handleRouteChange = () => {
      if (identified && analyticsApi) {
        setTimeout(() => {
          analyticsApi.page();
        }, 300);
      }
    };

    // Listen for route changes using location
    handleRouteChange();

  }, [analyticsReady, analyticsApi, location, identified]);
}

export function HubspotAnalytics() {
  useSegmentAnalytics();

  return null;
}
